module.exports = __webpack_public_path__ + "static/media/hr.c0edd843.jpeg";